// extracted by mini-css-extract-plugin
export default {"infoItem":"PetitionMetadata_infoItem__E3vE5","icon":"PetitionMetadata_icon__+zR1V","date":"PetitionMetadata_date__J-Y02","hr":"PetitionMetadata_hr__qeuP9"};